const BASE_URL = process.env.REACT_APP_BASE_URL || '';

// ⬅ פונקציית fetch עם AbortController — זהה לשלך
async function fetchWithTimeout(url, options = {}, timeout = 10000) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  try {
    const res = await fetch(url, { signal: controller.signal, ...options });
    return res;
  } finally {
    clearTimeout(id);
  }
}

/**
 * --------------------------------------------------------------------------------
 *  ✨ getRecommendations – API להמלצות
 *  מחזיר את כל ההמלצות מהשרת שלך: '/api/recommendations'
 *  (תתאימי את הנתונים לפי מה שהשרת שלך מחזיר)
 * --------------------------------------------------------------------------------
 */
export async function getRecommendations(timeout = 100000) {
  const url = `${BASE_URL}/api/recommendations`;
  console.debug('[recommendationsApi] fetching', url, 'timeout=', timeout);

  let res;
  try {
    // ⭐ כאן יכולה להיכנס לוגיקה נוספת בעתיד – למשל header עם token
    res = await fetchWithTimeout(url, { method: 'GET' }, timeout);

  } catch (err) {
    if (err.name === 'AbortError') {
      throw new Error('Request timed out');
    }
    throw err;
  }

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Failed to fetch recommendations: ${res.status} ${text}`);
  }

  const data = await res.json();
  return data;
}

export default { getRecommendations };
